import React from 'react';
import Modal from '../shared/RespModal';
import Button from '../shared/Button';
import '../../css/shared/DeleteRoleModal.css';
class DeleteAssignRoleModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasOpen: true
        }
    }
    render() {
        return (
            <Modal hasOpen={this.props.hasOpen}>
                <div>
                    <div className="deletemodal">
                        {this.props.children}
                    </div>
                    <div className="buttonContainer">
                        <Button
                            type="button"
                            class="yesbutton"
                            onClick={this.props.onYesClick}
                        >Yes</Button>
                        <Button
                            type="button"
                            class="nobutton"
                            onClick={this.props.onClick}
                        >No</Button>
                    </div>
                </div>
            </Modal>
        );
    }
}
export default DeleteAssignRoleModal;